import React, { useRef, useState, useEffect } from 'react'
import { Graph, DefaultLink } from '@visx/network';
import { useColorScheme } from '@mui/joy/styles';

function build_nodes(tuple, level = 1, source = null) {
  const nodes = [];
  if (level === 1){
    nodes.push(source);
  }
  for (let i = 0; i < tuple.length; i++) {
    const node = { id: JSON.stringify(tuple[i]),  source: source, level: level }
    nodes.push(node);
    if (Array.isArray(tuple[i])) {
      nodes.push(...build_nodes(tuple[i], level + 1, node));
    }
  }
  return nodes;
}

function DecayGraph(props) {
  const { mode } = useColorScheme();
  const isDark = mode === 'dark';
  const nodeFill = isDark ? '#DAA520' : '#90CAF9';
  const textFill = isDark ? '#0A0A0A' : '#212121';

  const tuple = props.tuple;
  const containerRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
      setSize({ width, height });
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);
  const root = { id: '0', x: 50, y: 50, source: null, level: 0 };
  const nodes = build_nodes(tuple, 1, root, 50, 25);

  const nNodes = tuple.flat(Infinity).length;
  const levelSlots = {};
  for (let i = 0; i < nNodes; i++) {
    levelSlots[i] = nNodes; // Key and value are both the integer
  } 

  function set_positions(node, i) {
    const level = node.level;
    const n = levelSlots[level];
    const x = (level + 1) * 40;
    const y = (-1 * n * 40)  + nNodes* 45 ;
    levelSlots[level] = n - 1;
    node.x = x;
    node.y = y;
    return node;
  }



  const unused = nodes.map((node, i) => ( set_positions(node, i) ));
  const temp_links = nodes.map((node, i) => ({ source: node.source, target: node }));
  const links = temp_links.slice(1);
  const graph = { nodes, links };

  const nodeRadius = 15;
  const padding = 5;
  const xs = nodes.map(n => n.x);
  const ys = nodes.map(n => n.y);
  const minX = Math.min(...xs) - nodeRadius - padding;
  const minY = Math.min(...ys) - nodeRadius - padding;
  const maxX = Math.max(...xs) + nodeRadius + padding;
  const maxY = Math.max(...ys) + nodeRadius + padding;
  const viewBox = `${minX} ${minY} ${maxX - minX} ${maxY - minY}`;

  function customNode(node_data) {
    const { node } = node_data;
    return (
      <g>
        <circle r={nodeRadius} fill={nodeFill} />
        <text fontSize={12} dominantBaseline={"middle"} textAnchor={"middle"} fill={textFill}>
          {node.id.replaceAll("[", "").replaceAll("]", "").replaceAll(",", "")}
        </text>
      </g>
    );
  }
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div ref={containerRef} style={{ position: 'absolute', inset: 0 }}>
        {size.width > 0 && size.height > 0 && (
          <svg
            width={size.width}
            height={size.height}
            viewBox={viewBox}
            preserveAspectRatio="xMidYMid meet"
          >
            <Graph graph={graph} linkComponent={DefaultLink} nodeComponent={customNode} />
          </svg>
        )}
      </div>
    </div>
  )
}

export default DecayGraph;